import { deleteObjectProperties } from 'CorePackage/MainModule/common/deleteObjectProperties';
import { convertKnmDocumentAttachmentsFormValuesToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';
import { IKnmDocument } from 'APIPackage/KnmModule/interfaces/IKnmDocument';
import { IKnmFormDocument } from 'KnmPackage/KnmDocumentsModule/interfaces/IKnmFormDocument';

import { handleReactQuillDeltaValue } from '../../../functions/handleReactQuillDeltaValue';

export const convertActEventDocumentsFormValueToKnmData = (
  documents: (IKnmFormDocument | undefined)[] | undefined,
): IKnmDocument[] | null => {
  if (!documents) {
    return null;
  }

  return documents.map(item => ({
    active: item?.active || null,
    attachments: convertKnmDocumentAttachmentsFormValuesToKnmData(item?.attachments),
    correlationToken: item?.correlationToken || null,
    description: item?.description || null,
    descriptionReactQuillEditor: handleReactQuillDeltaValue(
      item?.descriptionReactQuillEditor || item?.description || null,
    ),
    guid: item?.guid || null,
    type: item?.type ? deleteObjectProperties(item.type, ['label', 'value']) : null,
  }));
};
